import { useContext } from 'react';
import { FeatureFlagContext, type FeatureFlags } from './FeatureFlagContext';

export type { FeatureFlags };

export function useFeatureFlag(flag: keyof FeatureFlags): boolean {
  const flags = useContext(FeatureFlagContext);
  return flags[flag];
}

export function useFeatureFlags(): FeatureFlags {
  return useContext(FeatureFlagContext);
}
